{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/shortcode",
	"title": "Shortcode",
	"category": "widgets",
	"description": "Insert additional custom elements with a WordPress shortcode.",
	"textdomain": "default",
	"attributes": {
		"text": {
			"type": "string",
			"source": "raw",
			"role": "content"
		}
	},
	"supports": {
		"className": false,
		"customClassName": false,
		"html": false,
		"customCSS": false,
		"visibility": false
	},
	"editorStyle": "wp-block-shortcode-editor"
}
